import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import dragButton from "../../../assets/TicketCard/dragButton.svg";
import { DeleteQuickButton, EditQuickButton } from "../Buttons";


const DragDropTable = ({
    handleDragEnd = () => { },
    columns = [],
    rowData = [],
    onEdit = () => { },
    onDelete = () => { },
    getItemId,
    getItemDisplayValue,
    droppableId = "droppable",
    keyPrefix = "item"
}) => {
    return (
        <>
            <div className="mt-3 w-100">
                <DragDropContext onDragEnd={handleDragEnd}>
                    <table className="table borderd">
                        <thead className="custom-table-heading">
                            <tr>
                                <th className="custom-empty-th"> </th>
                                {columns?.map((content, index) => {
                                    if (content === "Quick Actions")
                                        return <th key={index} className="text-center">{content}</th>;
                                    else return <th key={index} className="text-center">{content}</th>;
                                })}
                            </tr>
                        </thead>
                        <Droppable droppableId={droppableId}>
                            {provider => (
                                <tbody
                                    ref={provider.innerRef}
                                    {...provider.droppableProps}
                                >
                                    {rowData?.map((value, index) => (
                                        <Draggable
                                            key={`${keyPrefix}-${getItemId(value)}`}
                                            draggableId={`${keyPrefix}-${getItemId(value)}`}
                                            index={index}
                                        >
                                            {provider => (
                                                <tr
                                                    {...provider.draggableProps}
                                                    ref={provider.innerRef}
                                                    style={{
                                                        ...provider.draggableProps.style,
                                                        left: "auto !important",
                                                        top: "auto !important",
                                                        transition: 'transform 0.2s ease',
                                                    }}
                                                >
                                                    <td
                                                        {...provider.dragHandleProps}
                                                        id="1"
                                                        style={{ width: "3%" }}
                                                    >
                                                        <img
                                                            src={dragButton}
                                                            className="pl-2 pr-3 dragCus"
                                                            alt="drag"
                                                        />
                                                    </td>

                                                    <td
                                                        className="text-center"
                                                        style={{ width: "30%" }}
                                                    >
                                                        {getItemDisplayValue(value)}
                                                    </td>

                                                    <td
                                                        className="custom-quick-action-row text-center mr-4"
                                                        style={{ width: "15%" }}
                                                    >
                                                        <span className="custom-action-icons"></span>
                                                        <span className="custom-action-icons px-2">
                                                            <EditQuickButton
                                                                onClick={() => onEdit(value)}
                                                            />
                                                        </span>
                                                        <span className="custom-action-icons px-2">
                                                            <DeleteQuickButton
                                                                onClick={() => onDelete(value)}
                                                            />
                                                        </span>
                                                    </td>
                                                </tr>
                                            )}
                                        </Draggable>
                                    ))}
                                    {provider.placeholder}
                                </tbody>
                            )}
                        </Droppable>
                    </table>
                </DragDropContext>
            </div>
            <style>
                {`
                    .custom-table-heading{
                        background: #F5F5F0;
                    }
                    td, tr{
                        border: none;
                    }
                    .table th{
                        border-top: none;
                    }
                `}
            </style>
        </>
    )
}

export default DragDropTable;
